// Port of puttr-app/components/common/Avatar.js: photo or initial on a brand
// colour picked from the name, with a green ring for members.
import React from 'react';
import { primaryGreen } from '../../constants/Colors';

const BRAND_COLORS = [
  '#2D8C3C', '#036b36', '#7ad446', '#1B6B2A', '#4CAF50', '#2E7D32', '#388E3C', '#43A047',
];

function getColorForName(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return BRAND_COLORS[Math.abs(hash) % BRAND_COLORS.length];
}

export default function Avatar({ displayName, photoURL, isMember, size = 60 }) {
  const ringWidth = Math.max(2, Math.round(size * 0.04));
  const ringGap = Math.max(1.5, Math.round(size * 0.03));
  const name = displayName || '';
  const initial = name ? name.substring(0, 1).toUpperCase() : '?';
  const bgColor = name ? getColorForName(name) : BRAND_COLORS[0];
  const innerSize = size - (ringWidth + ringGap) * 2;
  const hasPhoto = photoURL && photoURL !== '';

  const outer = {
    width: size,
    height: size,
    borderRadius: '50%',
    border: `${ringWidth}px solid ${isMember ? primaryGreen : 'rgba(255,255,255,0.1)'}`,
    boxShadow: isMember ? `0 0 6px ${primaryGreen}66` : 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    flexShrink: 0,
  };
  const inner = {
    width: innerSize,
    height: innerSize,
    borderRadius: '50%',
    backgroundColor: bgColor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    color: '#fff',
    fontWeight: 700,
    fontSize: Math.round(innerSize * 0.45),
    lineHeight: 1,
  };

  return (
    <div style={outer}>
      <div style={inner}>
        {hasPhoto ? (
          <img src={photoURL} alt={name} width={innerSize} height={innerSize} style={{ objectFit: 'cover' }} />
        ) : initial}
      </div>
    </div>
  );
}
